export const numberFormatter = new Intl.NumberFormat("en-US");

export const numberFormatterWithCurrency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});
